import { useSearchParams } from "react-router-dom";
import queryString from "query-string";
import { Constants } from "../constant";

const PAGE = "pageNumber";
const PAGE_SIZE = "pageSize";

function useParamsQuery() {
  const [urlSearchParams] = useSearchParams();

  const getQueryObject = () => {
    const query = urlSearchParams.toString();
    return queryString.parse(query);
  };

  const getQueryParams = (queryParams) => {
    const params = {
      pageNumber: queryParams?.pageNumber || 0,
      pageSize: queryParams?.pageSize || Constants.DEFAULT_PAGE_SIZE,
    };
    const updatedQueryParams = { ...queryParams };
    delete updatedQueryParams[PAGE];
    delete updatedQueryParams[PAGE_SIZE];
    return [updatedQueryParams, params];
  };
  return {
    getQueryObject,
    getQueryParams,
    urlSearchParams,
  };
}

export default useParamsQuery;
